import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Edit Line Item", -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Description", -1)
const _hoisted_5 = {
  key: 0,
  class: "form-field"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Total Amount($)", -1)
const _hoisted_7 = {
  key: 1,
  class: "form-field"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Amount($)", -1)
const _hoisted_9 = {
  key: 2,
  class: "form-field"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Quantity", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Update Line Item", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Cancel ")

import { ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  lineItemId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);

const router = useRouter();
const lineItem = ref();
const formFields = ref({
  action: "",
  description: "",
  amount: "",
});
// const lineItem = ref();
const errors = ref("");


async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  delete json.action;
  if (lineItem.value.amount_paid != 0) {
    delete json.amount;
  }
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `line_items/?id=${props.lineItemId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PUT",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    router.push({
      name: "customer_detail_ess",
      params: {
        id: props.customerId,
        facilityId: props.facilityId,
      },
    });
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getLineItem() {
  errors.value = "";
  const response = await api({
    url: `line_items/?id=${props.lineItemId}&single=${true}&facilityId=${
      props.facilityId
    }`,
  });
  if (response.status == 200) {
    lineItem.value = response.body;
    formFields.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getLineItem();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    (lineItem.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.description) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, formFields.value.description]
            ])
          ]),
          (formFields.value.action == 'product' && lineItem.value.amount_paid == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.amount) = $event)),
                  type: "decimal",
                  required: ""
                }, null, 512), [
                  [_vModelText, formFields.value.amount]
                ])
              ]))
            : (lineItem.value.amount_paid == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.amount) = $event)),
                    type: "decimal",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.amount]
                  ])
                ]))
              : _createCommentVNode("", true),
          (formFields.value.action == 'product')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lineItem.value.quantity) = $event)),
                  type: "number",
                  disabled: ""
                }, null, 512), [
                  [_vModelText, lineItem.value.quantity]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_11,
          _createVNode(_component_RouterLink, {
            to: {
        name: 'payment',
        params: {
          customerId: __props.customerId,
          customerName: __props.customerName,
          facilityId: __props.facilityId,
        },
      },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["to"])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})